import api from "axios";

export const getUserData = async () => {
  return api
    .get("/showcase/userData")
    .then((response) => response.data.payload)
    .catch((error) => `showcase userData ${error}`);
};

export const getCarousel = async (key = null) => {
  return api
    .get(`/showcase/active-campaigns${key ? `/${key}` : ''}`)
    .then((response) => response.data.payload)
    .catch((error) => `showcase carousel ${error}`);
};
